import { Box, Typography } from '@mui/material';
import ReusableGrid from '../../../../components/Grid';
import DataNotFound from '../../../../components/Reports/DataNotFound';

export const TableForReusableGrid = ({ title, arr = [], columns }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
      <Typography variant="h5" fontWeight={600}>
        {title}
      </Typography>
      {arr.length === 0 ? (
        <DataNotFound />
      ) : (
        arr.map((item) => (
          <Box
            key={`${title}-${item.name}`}
            sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}
          >
            {item.name && (
              <Typography fontWeight={600} variant="h6">
                {item.name}
              </Typography>
            )}
            <ReusableGrid
              columns={columns}
              rows={item.items}
              footer={item.footer}
            />
          </Box>
        ))
      )}
    </Box>
  );
};
